export default {
  name: 'Filelist',
  props: ['data', 'path', 'filetitle'],
  data () {
    return {
      downloadingEl: []
    }
  },
  methods: {
    downloadfile (key) {
      this.downloadingEl[key] = true;
      this.$forceUpdate();
      const self = this;
      this.ApiRequest.request(this.path + '/' + this.data[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.downloadingEl[key] = false;
        self.$forceUpdate();
      });
    }
  }
}
